import { useEffect, useState } from 'react';
import customAxios from 'routes/Pages/util/Api';
import authHeader from 'services/auth/jwt/auth-header';

const useHazrdsDropdown = () => {
  const [dropdown, setDropdown] = useState({});

  // Keys you want right now
  const hazardKeys = ['groundSlope', 'groundCondition'];

  useEffect(() => {
    const fetchDropdowns = async () => {
      const results = {};

      for (const key of hazardKeys) {
        try {
          const res = await customAxios.get(`/GenTasks/GetDropdownList/${key}`, { headers: authHeader() });
          if (res.status === 200 && Array.isArray(res.data)) {
            results[key] = res.data.map(item => ({
              label: item.keyValue,
              value: item.keyValue,
            }));
          }
        } catch (err) {
          console.error(`❌ Error fetching dropdown for "${key}"`, err);
        }
      }

      setDropdown(results);
    };

    fetchDropdowns();
  }, []); // fetch immediately on mount

  return { dropdown };
};

export default useHazrdsDropdown;
